import React from 'react';
import {Link} from 'react-router-dom'

function SideBarTitle() {
  return (

	<div className="rc-post-list">
  <ul>
    <li>
      <div className="rc-post-thumb">
        <Link to="/blog-details"><img src="img/blog/rc_post_thumb01.jpg" alt="" /></Link>
      </div>
      <div className="rc-post-content">
        <h5 className="title"><Link to="/blog-details">Animalia Plus – Tout ce qu’il faut pour votre animal</Link></h5>
        <div className="rc-post-meta">
          <ul>
            <li><i className="far fa-calendar-alt" /> 15 Avril 2021</li>
            <li>Par <a href="/#">Admin</a></li>
          </ul>
        </div>
      </div>
    </li>
    <li>
      <div className="rc-post-thumb">
        <Link to="/blog-details"><img src="img/blog/rc_post_thumb02.jpg" alt="" /></Link>
      </div>
      <div className="rc-post-content">
        <h5 className="title"><Link to="/blog-details">Les animaux ont besoin d’une alimentation spéciale, comme les humains</Link></h5>
        <div className="rc-post-meta">
          <ul>
            <li><i className="far fa-calendar-alt" /> 15 Octobre 2021</li>
            <li>Par <a href="/#">Admin</a></li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</div>

  )
}

export default SideBarTitle;
